<template lang="pug">
.list-search-container
  .search-input
    input(placeholder="输入关键词搜索" :value="value"
      @input="handleInput")
    .icon(@click="handleSearch")
</template>

<script>
export default {
  name: "ListSearch",
  props: {
    value: String,
  },
  methods: {
    handleInput(e) {
      this.$emit('input', e.target.value)
    },
    handleSearch() {
      this.$emit('change');
    }
  }
}
</script>

<style lang="scss" scoped>
.list-search-container{
  padding: 12px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  .search-input{
    border: 1px solid rgba(0, 0, 0, 0.1);
    @include size(206px, 32px);
    display: flex;
    input{
      flex: 1;
      display: block;
      border: none;
      outline: none;
      @include size(174px, 100%);
      padding: 0 0 0 12px;
      font-size: 12px;
      box-sizing: border-box;
    }
    .icon{
      @include square(32px);
      background: url("~@/assets/list/icon-search.svg") no-repeat center;
      cursor: pointer;
    }
  }
}
</style>
